import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Star, Trash2, Inbox } from 'lucide-react';
import { toast } from 'sonner';
import { api } from '../../api';

export const ReviewsList = ({ reviews, onDeleted }) => {
  const remove = async (id) => {
    if (!window.confirm('Delete this review permanently?')) return;
    try {
      await api.delete(`/admin/reviews/${id}`);
      onDeleted(id);
      toast.success('Review deleted');
    } catch (e) {
      toast.error('Failed to delete review');
    }
  };

  if (reviews.length === 0) {
    return (
      <Card className="border-0 shadow-sm"><CardContent className="p-12 text-center text-gray-500">
        <Inbox className="w-12 h-12 mx-auto mb-3 text-gray-300" />No reviews yet
      </CardContent></Card>
    );
  }

  return (
    <div className="space-y-3" data-testid="admin-reviews-list">
      {reviews.map((r) => (
        <Card key={r.review_id} className="border-0 shadow-sm" data-testid={`admin-review-${r.review_id}`}>
          <CardContent className="p-5 flex items-start gap-4">
            <img src={r.avatar || `https://ui-avatars.com/api/?name=${encodeURIComponent(r.name)}&background=0d9488&color=fff`} alt={r.name} className="w-11 h-11 rounded-full flex-shrink-0" />
            <div className="flex-1 min-w-0">
              <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                <p className="font-bold text-gray-900">{r.name}</p>
                {r.location && <p className="text-sm text-gray-500">{r.location}</p>}
                {r.destination && <span className="text-xs bg-teal-50 text-teal-700 px-2 py-0.5 rounded-full">{r.destination}</span>}
                <span className="flex">{[...Array(r.rating)].map((_, i) => <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />)}</span>
                <p className="text-xs text-gray-400">{new Date(r.created_at).toLocaleDateString()}</p>
              </div>
              <p className="text-gray-700 mt-1">{r.text}</p>
            </div>
            <Button data-testid={`review-delete-${r.review_id}`} variant="ghost" size="sm" onClick={() => remove(r.review_id)} className="text-red-600 hover:bg-red-50 hover:text-red-700">
              <Trash2 className="w-4 h-4" />
            </Button>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
